import Button from "@mui/material/Button";
import { styled } from "@mui/system";

export const StyledButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1),
}));
